"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
var messages = (0, react_intl_1.defineMessages)({
    // Device Categories
    aftersalesServices: {
        id: 'categories.aftersalesServices',
        defaultMessage: 'Aftersales Services',
        description: 'Display name for Aftersales Services device category',
    },
    assembly: {
        id: 'categories.assembly',
        defaultMessage: 'Assembly',
        description: 'Display name for Assembly device category',
    },
    balers: {
        id: 'categories.balers',
        defaultMessage: 'Balers',
        description: 'Display name for Balers device category',
    },
    combines: {
        id: 'categories.combines',
        defaultMessage: 'Combines',
        description: 'Display name for Combines device category',
    },
    commercialVehicles: {
        id: 'categories.commercialVehicles',
        defaultMessage: 'Commercial Vehicles',
        description: 'Display name for Commercial Vehicles device category',
    },
    constructionEquipment: {
        id: 'categories.constructionEquipment',
        defaultMessage: 'Construction Equipment',
        description: 'Display name for Construction Equipment device category',
    },
    forageHarvester: {
        id: 'categories.forageHarvester',
        defaultMessage: 'Forage Harvester',
        description: 'Display name for Forage Harvester device category',
    },
    forestMachinery: {
        id: 'categories.forestMachinery',
        defaultMessage: 'Forest Machinery',
        description: 'Display name for Forest Machinery device category',
    },
    generators: {
        id: 'categories.generators',
        defaultMessage: 'Generators',
        description: 'Display name for Generators device category',
    },
    grainHandlingEquipment: {
        id: 'categories.grainHandlingEquipment',
        defaultMessage: 'Grain Handling Equipment',
        description: 'Display name for Grain Handling Equipment device category',
    },
    groundcareGolfSportsTurf: {
        id: 'categories.groundcareGolfSportsTurf',
        defaultMessage: 'Groundcare, Golf & Sports Turf',
        description: 'Display name for Groundcare, Golf & Sports Turf device category',
    },
    hayForage: {
        id: 'categories.hayForage',
        defaultMessage: 'Hay & Forage',
        description: 'Display name for Hay & Forage device category',
    },
    highwayGrasslandFarmMaintenance: {
        id: 'categories.highwayGrasslandFarmMaintenance',
        defaultMessage: 'Highway, Grassland & Farm Maintenance',
        description: 'Display name for Highway, Grassland & Farm Maintenance device category',
    },
    irrigationEquipment: {
        id: 'categories.irrigationEquipment',
        defaultMessage: 'Irrigation Equipment',
        description: 'Display name for Irrigation Equipment device category',
    },
    lawnGardenEquipment: {
        id: 'categories.lawnGardenEquipment',
        defaultMessage: 'Lawn & Garden Equipment',
        description: 'Display name for Lawn & Garden Equipment device category',
    },
    livestockEquipment: {
        id: 'categories.livestockEquipment',
        defaultMessage: 'Livestock Equipment',
        description: 'Display name for Livestock Equipment device category',
    },
    manureHandlingEquipment: {
        id: 'categories.manureHandlingEquipment',
        defaultMessage: 'Manure Handling Equipment',
        description: 'Display name for Manure Handling Equipment device category',
    },
    materialHandling: {
        id: 'categories.materialHandling',
        defaultMessage: 'Material Handling',
        description: 'Display name for Material Handling device category',
    },
    miscellaneous: {
        id: 'categories.miscellaneous',
        defaultMessage: 'Miscellaneous',
        description: 'Display name for Miscellaneous device category',
    },
    parts: {
        id: 'categories.parts',
        defaultMessage: 'Parts',
        description: 'Display name for Parts device category',
    },
    plantersDrills: {
        id: 'categories.plantersDrills',
        defaultMessage: 'Planters & Drills',
        description: 'Display name for Planters & Drills device category',
    },
    potatoEquipment: {
        id: 'categories.potatoEquipment',
        defaultMessage: 'Potato Equipment',
        description: 'Display name for Potato Equipment device category',
    },
    proteinEquipment: {
        id: 'categories.proteinEquipment',
        defaultMessage: 'Protein Equipment',
        description: 'Display name for Protein Equipment device category',
    },
    services: {
        id: 'categories.services',
        defaultMessage: 'Services',
        description: 'Display name for Services device category',
    },
    slurryHandlingEquipment: {
        id: 'categories.slurryHandlingEquipment',
        defaultMessage: 'Slurry Handling Equipment',
        description: 'Display name for Slurry Handling Equipment device category',
    },
    snowEquipment: {
        id: 'categories.snowEquipment',
        defaultMessage: 'Snow Equipment',
        description: 'Display name for Snow Equipment device category',
    },
    sprayers: {
        id: 'categories.sprayers',
        defaultMessage: 'Sprayers',
        description: 'Display name for Sprayers device category',
    },
    spreader: {
        id: 'categories.spreader',
        defaultMessage: 'Spreader',
        description: 'Display name for Spreader device category',
    },
    sugarBeetEquipment: {
        id: 'categories.sugarBeetEquipment',
        defaultMessage: 'Sugar Beet Equipment',
        description: 'Display name for Sugar Beet Equipment device category',
    },
    sugarCaneEquipment: {
        id: 'categories.sugarCaneEquipment',
        defaultMessage: 'Sugar Cane Equipment',
        description: 'Display name for Sugar Cane Equipment device category',
    },
    technologyGuidanceSolution: {
        id: 'categories.technologyGuidanceSolution',
        defaultMessage: 'Technology & Guidance Solution',
        description: 'Display name for Technology & Guidance Solution device category',
    },
    tillage: {
        id: 'categories.tillage',
        defaultMessage: 'Tillage',
        description: 'Display name for Tillage device category',
    },
    tractors: {
        id: 'categories.tractors',
        defaultMessage: 'Tractors',
        description: 'Display name for Tractors device category',
    },
    trailedEquipment: {
        id: 'categories.trailedEquipment',
        defaultMessage: 'Trailed Equipment',
        description: 'Display name for Trailed Equipment device category',
    },
    utilityLeisureVehicles: {
        id: 'categories.utilityLeisureVehicles',
        defaultMessage: 'Utility/Leisure Vehicles',
        description: 'Display name for Utility/Leisure Vehicles device category',
    },
    vegetableEquipment: {
        id: 'categories.vegetableEquipment',
        defaultMessage: 'Vegetable Equipment',
        description: 'Display name for Vegetable Equipment device category',
    },
    vineyardSpecialistFruitEquipment: {
        id: 'categories.vineyardSpecialistFruitEquipment',
        defaultMessage: 'Vineyard & Specialist Fruit Equipment',
        description: 'Display name for Vineyard & Specialist Fruit Equipment device category',
    },
    // Device Subcategories
    '3PlMounted': {
        id: 'categories.3PlMounted',
        defaultMessage: '3Pl Mounted',
        description: 'Display name for 3Pl Mounted subcategory',
    },
    aeratonEquipment: {
        id: 'categories.aeratonEquipment',
        defaultMessage: 'Aeraton Equipment',
        description: 'Display name for Aeraton Equipment subcategory',
    },
    aerialWorkPlatforms: {
        id: 'categories.aerialWorkPlatforms',
        defaultMessage: 'Aerial Work Platforms',
        description: 'Display name for Aerial Work Platforms subcategory',
    },
    applicationRateControllers: {
        id: 'categories.applicationRateControllers',
        defaultMessage: 'Application Rate Controllers',
        description: 'Display name for Application Rate Controllers subcategory',
    },
    articulated: {
        id: 'categories.articulated',
        defaultMessage: 'Articulated',
        description: 'Display name for Articulated subcategory',
    },
    attachments: {
        id: 'categories.attachments',
        defaultMessage: 'Attachments',
        description: 'Display name for Attachments subcategory',
    },
    atvUtvRtvAccessoriesEquipment: {
        id: 'categories.atvUtvRtvAccessoriesEquipment',
        defaultMessage: 'ATV/UTV/RTV Accessories Equipment',
        description: 'Display name for ATV/UTV/RTV Accessories Equipment subcategory',
    },
    atvUtvRtVs: {
        id: 'categories.atvUtvRtVs',
        defaultMessage: "ATV/UTV/RTV's",
        description: "Display name for ATV/UTV/RTV's subcategory",
    },
    backhoeLoaders: {
        id: 'categories.backhoeLoaders',
        defaultMessage: 'Backhoe Loaders',
        description: 'Display name for Backhoe Loaders subcategory',
    },
    backhoes: {
        id: 'categories.backhoes',
        defaultMessage: 'Backhoes',
        description: 'Display name for Backhoes subcategory',
    },
    baleAccumulatorsLoaders: {
        id: 'categories.baleAccumulatorsLoaders',
        defaultMessage: 'Bale Accumulators/Loaders',
        description: 'Display name for Bale Accumulators/Loaders subcategory',
    },
    balerWrapperCombinations: {
        id: 'categories.balerWrapperCombinations',
        defaultMessage: 'Baler Wrapper Combinations',
        description: 'Display name for Baler Wrapper Combinations subcategory',
    },
    baleTrailers: {
        id: 'categories.baleTrailers',
        defaultMessage: 'Bale Trailers',
        description: 'Display name for Bale Trailers subcategory',
    },
    baleWrappers: {
        id: 'categories.baleWrappers',
        defaultMessage: 'Bale Wrappers',
        description: 'Display name for Bale Wrappers subcategory',
    },
    band: {
        id: 'categories.band',
        defaultMessage: 'Band',
        description: 'Display name for Band subcategory',
    },
    blowers: {
        id: 'categories.blowers',
        defaultMessage: 'Blowers',
        description: 'Display name for Blowers subcategory',
    },
    bowsers: {
        id: 'categories.bowsers',
        defaultMessage: 'Bowsers',
        description: 'Display name for Bowsers subcategory',
    },
    buildingEquipment: {
        id: 'categories.buildingEquipment',
        defaultMessage: 'Building Equipment',
        description: 'Display name for Building Equipment subcategory',
    },
    bunkerRakes: {
        id: 'categories.bunkerRakes',
        defaultMessage: 'Bunker Rakes',
        description: 'Display name for Bunker Rakes subcategory',
    },
    cableWinches: {
        id: 'categories.cableWinches',
        defaultMessage: 'Cable Winches',
        description: 'Display name for Cable Winches subcategory',
    },
    chiselCultivators: {
        id: 'categories.chiselCultivators',
        defaultMessage: 'Chisel Cultivators',
        description: 'Display name for Chisel Cultivators subcategory',
    },
    cleanerLoaders: {
        id: 'categories.cleanerLoaders',
        defaultMessage: 'Cleaner Loaders',
        description: 'Display name for Cleaner Loaders subcategory',
    },
    commercialMowers: {
        id: 'categories.commercialMowers',
        defaultMessage: 'Commercial Mowers',
        description: 'Display name for Commercial Mowers subcategory',
    },
    compacts: {
        id: 'categories.compacts',
        defaultMessage: 'Compacts',
        description: 'Display name for Compacts subcategory',
    },
    concreteMixers: {
        id: 'categories.concreteMixers',
        defaultMessage: 'Concrete Mixers',
        description: 'Display name for Concrete Mixers subcategory',
    },
    conditioners: {
        id: 'categories.conditioners',
        defaultMessage: 'Conditioners',
        description: 'Display name for Conditioners subcategory',
    },
    constructionAttachments: {
        id: 'categories.constructionAttachments',
        defaultMessage: 'Construction Attachments',
        description: 'Display name for Construction Attachments subcategory',
    },
    constructionCompressors: {
        id: 'categories.constructionCompressors',
        defaultMessage: 'Construction Compressors',
        description: 'Display name for Construction Compressors subcategory',
    },
    conveyors: {
        id: 'categories.conveyors',
        defaultMessage: 'Conveyors',
        description: 'Display name for Conveyors subcategory',
    },
    cucumberHarvestingMachines: {
        id: 'categories.cucumberHarvestingMachines',
        defaultMessage: 'Cucumber-Harvesting Machines',
        description: 'Display name for Cucumber-Harvesting Machines subcategory',
    },
    demountable: {
        id: 'categories.demountable',
        defaultMessage: 'Demountable',
        description: 'Display name for Demountable subcategory',
    },
    diesel: {
        id: 'categories.diesel',
        defaultMessage: 'Diesel',
        description: 'Display name for Diesel subcategory',
    },
    discHarrows: {
        id: 'categories.discHarrows',
        defaultMessage: 'Disc Harrows',
        description: 'Display name for Disc Harrows subcategory',
    },
    ditchers: {
        id: 'categories.ditchers',
        defaultMessage: 'Ditchers',
        description: 'Display name for Ditchers subcategory',
    },
    drillCombinations: {
        id: 'categories.drillCombinations',
        defaultMessage: 'Drill Combinations',
        description: 'Display name for Drill Combinations subcategory',
    },
    dumpers: {
        id: 'categories.dumpers',
        defaultMessage: 'Dumpers',
        description: 'Display name for Dumpers subcategory',
    },
    dumpTrucks: {
        id: 'categories.dumpTrucks',
        defaultMessage: 'Dump Trucks',
        description: 'Display name for Dump Trucks subcategory',
    },
    elevatorsAugers: {
        id: 'categories.elevatorsAugers',
        defaultMessage: 'Elevators/Augers',
        description: 'Display name for Elevators/Augers subcategory',
    },
    embankmentMowers: {
        id: 'categories.embankmentMowers',
        defaultMessage: 'Embankment Mowers',
        description: 'Display name for Embankment Mowers subcategory',
    },
    engines: {
        id: 'categories.engines',
        defaultMessage: 'Engines',
        description: 'Display name for Engines subcategory',
    },
    eTractor: {
        id: 'categories.eTractor',
        defaultMessage: 'eTractor',
        description: 'Display name for eTractor subcategory',
    },
    extendedWarranties: {
        id: 'categories.extendedWarranties',
        defaultMessage: 'Extended Warranties',
        description: 'Display name for Extended Warranties subcategory',
    },
    fairwayMowers: {
        id: 'categories.fairwayMowers',
        defaultMessage: 'Fairway Mowers',
        description: 'Display name for Fairway Mowers subcategory',
    },
    fencingEquipment: {
        id: 'categories.fencingEquipment',
        defaultMessage: 'Fencing Equipment',
        description: 'Display name for Fencing Equipment subcategory',
    },
    fieldCultivators: {
        id: 'categories.fieldCultivators',
        defaultMessage: 'Field Cultivators',
        description: 'Display name for Field Cultivators subcategory',
    },
    firewoodProcessors: {
        id: 'categories.firewoodProcessors',
        defaultMessage: 'Firewood Processors',
        description: 'Display name for Firewood Processors subcategory',
    },
    forageWagons: {
        id: 'categories.forageWagons',
        defaultMessage: 'Forage Wagons',
        description: 'Display name for Forage Wagons subcategory',
    },
    forestryCutters: {
        id: 'categories.forestryCutters',
        defaultMessage: 'Forestry Cutters',
        description: 'Display name for Forestry Cutters subcategory',
    },
    forwarders: {
        id: 'categories.forwarders',
        defaultMessage: 'Forwarders',
        description: 'Display name for Forwarders subcategory',
    },
    forwardingTrailers: {
        id: 'categories.forwardingTrailers',
        defaultMessage: 'Forwarding Trailers',
        description: 'Display name for Forwarding Trailers subcategory',
    },
    frontLoaders: {
        id: 'categories.frontLoaders',
        defaultMessage: 'Front Loaders',
        description: 'Display name for Front Loaders subcategory',
    },
    gas: {
        id: 'categories.gas',
        defaultMessage: 'Gas',
        description: 'Display name for Gas subcategory',
    },
    golfCarts: {
        id: 'categories.golfCarts',
        defaultMessage: 'Golf Carts',
        description: 'Display name for Golf Carts subcategory',
    },
    graders: {
        id: 'categories.graders',
        defaultMessage: 'Graders',
        description: 'Display name for Graders subcategory',
    },
    grainCarsChaserBins: {
        id: 'categories.grainCarsChaserBins',
        defaultMessage: 'Grain Cars/Chaser Bins',
        description: 'Display name for Grain Cars/Chaser Bins subcategory',
    },
    grainCartsChaserBins: {
        id: 'categories.grainCartsChaserBins',
        defaultMessage: 'Grain Carts/Chaser Bins',
        description: 'Display name for Grain Carts/Chaser Bins subcategory',
    },
    grainCleaning: {
        id: 'categories.grainCleaning',
        defaultMessage: 'Grain Cleaning',
        description: 'Display name for Grain Cleaning subcategory',
    },
    grainDryers: {
        id: 'categories.grainDryers',
        defaultMessage: 'Grain Dryers',
        description: 'Display name for Grain Dryers subcategory',
    },
    grainIntakes: {
        id: 'categories.grainIntakes',
        defaultMessage: 'Grain Intakes',
        description: 'Display name for Grain Intakes subcategory',
    },
    grainMills: {
        id: 'categories.grainMills',
        defaultMessage: 'Grain Mills',
        description: 'Display name for Grain Mills subcategory',
    },
    grapeHarvesters: {
        id: 'categories.grapeHarvesters',
        defaultMessage: 'Grape Harvesters',
        description: 'Display name for Grape Harvesters subcategory',
    },
    grassAndFieldHarrows: {
        id: 'categories.grassAndFieldHarrows',
        defaultMessage: 'Grass and Field Harrows',
        description: 'Display name for Grass and Field Harrows subcategory',
    },
    grasslandMowers: {
        id: 'categories.grasslandMowers',
        defaultMessage: 'Grassland Mowers',
        description: 'Display name for Grassland Mowers subcategory',
    },
    grasslandSeeders: {
        id: 'categories.grasslandSeeders',
        defaultMessage: 'Grassland Seeders',
        description: 'Display name for Grassland Seeders subcategory',
    },
    grasslandWeeders: {
        id: 'categories.grasslandWeeders',
        defaultMessage: 'Grassland Weeders',
        description: 'Display name for Grassland Weeders subcategory',
    },
    greensMowers: {
        id: 'categories.greensMowers',
        defaultMessage: 'Greens Mowers',
        description: 'Display name for Greens Mowers subcategory',
    },
    guidanceSteering: {
        id: 'categories.guidanceSteering',
        defaultMessage: 'Guidance & Steering',
        description: 'Display name for Guidance & Steering subcategory',
    },
    hammersRockBreakers: {
        id: 'categories.hammersRockBreakers',
        defaultMessage: 'Hammers/Rock Breakers',
        description: 'Display name for Hammers/Rock Breakers subcategory',
    },
    handHeldPowerTools: {
        id: 'categories.handHeldPowerTools',
        defaultMessage: 'Hand-Held Power Tools',
        description: 'Display name for Hand-Held Power Tools subcategory',
    },
    harvesting: {
        id: 'categories.harvesting',
        defaultMessage: 'Harvesting',
        description: 'Display name for Harvesting subcategory',
    },
    harvestPreparation: {
        id: 'categories.harvestPreparation',
        defaultMessage: 'Harvest Preparation',
        description: 'Display name for Harvest Preparation subcategory',
    },
    headers: {
        id: 'categories.headers',
        defaultMessage: 'Headers',
        description: 'Display name for Headers subcategory',
    },
    hoofTrimmingChutes: {
        id: 'categories.hoofTrimmingChutes',
        defaultMessage: 'Hoof Trimming Chutes',
        description: 'Display name for Hoof Trimming Chutes subcategory',
    },
    hookLoadersMultiTrailers: {
        id: 'categories.hookLoadersMultiTrailers',
        defaultMessage: 'Hook Loaders/Multi Trailers',
        description: 'Display name for Hook Loaders/Multi Trailers subcategory',
    },
    hybrid: {
        id: 'categories.hybrid',
        defaultMessage: 'Hybrid',
        description: 'Display name for Hybrid subcategory',
    },
    industrialForklifts: {
        id: 'categories.industrialForklifts',
        defaultMessage: 'Industrial Forklifts',
        description: 'Display name for Industrial Forklifts subcategory',
    },
    inLineRippers: {
        id: 'categories.inLineRippers',
        defaultMessage: 'In Line Rippers',
        description: 'Display name for In Line Rippers subcategory',
    },
    irrigationBooms: {
        id: 'categories.irrigationBooms',
        defaultMessage: 'Irrigation Booms',
        description: 'Display name for Irrigation Booms subcategory',
    },
    irrigationGuns: {
        id: 'categories.irrigationGuns',
        defaultMessage: 'Irrigation Guns',
        description: 'Display name for Irrigation Guns subcategory',
    },
    irrigationPumps: {
        id: 'categories.irrigationPumps',
        defaultMessage: 'Irrigation Pumps',
        description: 'Display name for Irrigation Pumps subcategory',
    },
    irrigationReelSystems: {
        id: 'categories.irrigationReelSystems',
        defaultMessage: 'Irrigation Reel Systems',
        description: 'Display name for Irrigation Reel Systems subcategory',
    },
    landFinishers: {
        id: 'categories.landFinishers',
        defaultMessage: 'Land Finishers',
        description: 'Display name for Land Finishers subcategory',
    },
    largeSquare: {
        id: 'categories.largeSquare',
        defaultMessage: 'Large Square',
        description: 'Display name for Large Square subcategory',
    },
    lawnmowers: {
        id: 'categories.lawnmowers',
        defaultMessage: 'Lawnmowers',
        description: 'Display name for Lawnmowers subcategory',
    },
    leafRemovers: {
        id: 'categories.leafRemovers',
        defaultMessage: 'Leaf Removers',
        description: 'Display name for Leaf Removers subcategory',
    },
    livestockDrivetrains: {
        id: 'categories.livestockDrivetrains',
        defaultMessage: 'Livestock Drivetrains',
        description: 'Display name for Livestock Drivetrains subcategory',
    },
    livestockTrailers: {
        id: 'categories.livestockTrailers',
        defaultMessage: 'Livestock Trailers',
        description: 'Display name for Livestock Trailers subcategory',
    },
    logSaws: {
        id: 'categories.logSaws',
        defaultMessage: 'Log Saws',
        description: 'Display name for Log Saws subcategory',
    },
    logSplitters: {
        id: 'categories.logSplitters',
        defaultMessage: 'Log Splitters',
        description: 'Display name for Log Splitters subcategory',
    },
    lowLoaders: {
        id: 'categories.lowLoaders',
        defaultMessage: 'Low Loaders',
        description: 'Display name for Low Loaders subcategory',
    },
    minTill: {
        id: 'categories.minTill',
        defaultMessage: 'Min-Till',
        description: 'Display name for Min-Till subcategory',
    },
    mistblowers: {
        id: 'categories.mistblowers',
        defaultMessage: 'Mistblowers',
        description: 'Display name for Mistblowers subcategory',
    },
    mixersStirrers: {
        id: 'categories.mixersStirrers',
        defaultMessage: 'Mixers/Stirrers',
        description: 'Display name for Mixers/Stirrers subcategory',
    },
    mobileGrainDryers: {
        id: 'categories.mobileGrainDryers',
        defaultMessage: 'Mobile Grain Dryers',
        description: 'Display name for Mobile Grain Dryers subcategory',
    },
    motorHoes: {
        id: 'categories.motorHoes',
        defaultMessage: 'Motor Hoes',
        description: 'Display name for Motor Hoes subcategory',
    },
    mounted: {
        id: 'categories.mounted',
        defaultMessage: 'Mounted',
        description: 'Display name for Mounted subcategory',
    },
    mulcher: {
        id: 'categories.mulcher',
        defaultMessage: 'Mulcher',
        description: 'Display name for Mulcher subcategory',
    },
    offHighwayTrucks: {
        id: 'categories.offHighwayTrucks',
        defaultMessage: 'Off Highway Trucks',
        description: 'Display name for Off Highway Trucks subcategory',
    },
    otherAftersalesServices: {
        id: 'categories.otherAftersalesServices',
        defaultMessage: 'Other Aftersales Services',
        description: 'Display name for Other Aftersales Services subcategory',
    },
    otherAssemblies: {
        id: 'categories.otherAssemblies',
        defaultMessage: 'Other Assemblies',
        description: 'Display name for Other Assemblies subcategory',
    },
    otherBalers: {
        id: 'categories.otherBalers',
        defaultMessage: 'Other Balers',
        description: 'Display name for Other Balers subcategory',
    },
    otherCombines: {
        id: 'categories.otherCombines',
        defaultMessage: 'Other Combines',
        description: 'Display name for Other Combines subcategory',
    },
    otherCommercialVehicles: {
        id: 'categories.otherCommercialVehicles',
        defaultMessage: 'Other Commercial Vehicles',
        description: 'Display name for Other Commercial Vehicles subcategory',
    },
    otherConstructionEquipment: {
        id: 'categories.otherConstructionEquipment',
        defaultMessage: 'Other Construction Equipment',
        description: 'Display name for Other Construction Equipment subcategory',
    },
    otherForageHarvesters: {
        id: 'categories.otherForageHarvesters',
        defaultMessage: 'Other Forage Harvesters',
        description: 'Display name for Other Forage Harvesters subcategory',
    },
    otherForestMachinery: {
        id: 'categories.otherForestMachinery',
        defaultMessage: 'Other Forest Machinery',
        description: 'Display name for Other Forest Machinery subcategory',
    },
    otherGenerators: {
        id: 'categories.otherGenerators',
        defaultMessage: 'Other Generators',
        description: 'Display name for Other Generators subcategory',
    },
    otherGrainHandlingEquipment: {
        id: 'categories.otherGrainHandlingEquipment',
        defaultMessage: 'Other Grain Handling Equipment',
        description: 'Display name for Other Grain Handling Equipment subcategory',
    },
    otherGroundcareGolfSportsTurf: {
        id: 'categories.otherGroundcareGolfSportsTurf',
        defaultMessage: 'Other Groundcare, Golf & Sports Turf',
        description: 'Display name for Other Groundcare, Golf & Sports Turf subcategory',
    },
    otherHandtools: {
        id: 'categories.otherHandtools',
        defaultMessage: 'Other Handtools',
        description: 'Display name for Other Handtools subcategory',
    },
    otherHayForage: {
        id: 'categories.otherHayForage',
        defaultMessage: 'Other Hay & Forage',
        description: 'Display name for Other Hay & Forage subcategory',
    },
    otherHighwayGrasslandFarmMaintenance: {
        id: 'categories.otherHighwayGrasslandFarmMaintenance',
        defaultMessage: 'Other Highway, Grassland & Farm Maintenance',
        description: 'Display name for Other Highway, Grassland & Farm Maintenance subcategory',
    },
    otherIrrigationEquipment: {
        id: 'categories.otherIrrigationEquipment',
        defaultMessage: 'Other Irrigation Equipment',
        description: 'Display name for Other Irrigation Equipment subcategory',
    },
    otherLivestockEquipment: {
        id: 'categories.otherLivestockEquipment',
        defaultMessage: 'Other Livestock Equipment',
        description: 'Display name for Other Livestock Equipment subcategory',
    },
    otherManureHandlingEquipment: {
        id: 'categories.otherManureHandlingEquipment',
        defaultMessage: 'Other Manure Handling Equipment',
        description: 'Display name for Other Manure Handling Equipment subcategory',
    },
    otherMaterialHandling: {
        id: 'categories.otherMaterialHandling',
        defaultMessage: 'Other Material Handling',
        description: 'Display name for Other Material Handling subcategory',
    },
    otherParts: {
        id: 'categories.otherParts',
        defaultMessage: 'Other Parts',
        description: 'Display name for Other Parts subcategory',
    },
    otherPlantersDrills: {
        id: 'categories.otherPlantersDrills',
        defaultMessage: 'Other Planters & Drills',
        description: 'Display name for Other Planters & Drills subcategory',
    },
    otherPotatoEquipment: {
        id: 'categories.otherPotatoEquipment',
        defaultMessage: 'Other Potato Equipment',
        description: 'Display name for Other Potato Equipment subcategory',
    },
    otherProteinEquipment: {
        id: 'categories.otherProteinEquipment',
        defaultMessage: 'Other Protein Equipment',
        description: 'Display name for Other Protein Equipment subcategory',
    },
    otherServices: {
        id: 'categories.otherServices',
        defaultMessage: 'Other Services',
        description: 'Display name for Other Services subcategory',
    },
    otherSlurryHandlingEquipment: {
        id: 'categories.otherSlurryHandlingEquipment',
        defaultMessage: 'Other Slurry Handling Equipment',
        description: 'Display name for Other Slurry Handling Equipment subcategory',
    },
    otherSnowEquipment: {
        id: 'categories.otherSnowEquipment',
        defaultMessage: 'Other Snow Equipment',
        description: 'Display name for Other Snow Equipment subcategory',
    },
    otherSprayers: {
        id: 'categories.otherSprayers',
        defaultMessage: 'Other Sprayers',
        description: 'Display name for Other Sprayers subcategory',
    },
    otherSpreaders: {
        id: 'categories.otherSpreaders',
        defaultMessage: 'Other Spreaders',
        description: 'Display name for Other Spreaders subcategory',
    },
    otherSugarBeetEquipment: {
        id: 'categories.otherSugarBeetEquipment',
        defaultMessage: 'Other Sugar Beet Equipment',
        description: 'Display name for Other Sugar Beet Equipment subcategory',
    },
    otherSugarCaneEquipment: {
        id: 'categories.otherSugarCaneEquipment',
        defaultMessage: 'Other Sugar Cane Equipment',
        description: 'Display name for Other Sugar Cane Equipment subcategory',
    },
    otherTechnologyGuidanceSolutions: {
        id: 'categories.otherTechnologyGuidanceSolutions',
        defaultMessage: 'Other Technology & Guidance Solutions',
        description: 'Display name for Other Technology & Guidance Solutions subcategory',
    },
    otherTillage: {
        id: 'categories.otherTillage',
        defaultMessage: 'Other Tillage',
        description: 'Display name for Other Tillage subcategory',
    },
    otherTractors: {
        id: 'categories.otherTractors',
        defaultMessage: 'Other Tractors',
        description: 'Display name for Other Tractors subcategory',
    },
    otherTrailedEquipment: {
        id: 'categories.otherTrailedEquipment',
        defaultMessage: 'Other Trailed Equipment',
        description: 'Display name for Other Trailed Equipment subcategory',
    },
    otherUtilityLeisureVehicles: {
        id: 'categories.otherUtilityLeisureVehicles',
        defaultMessage: 'Other Utility/Leisure Vehicles',
        description: 'Display name for Other Utility/Leisure Vehicles subcategory',
    },
    otherVegetableEquipment: {
        id: 'categories.otherVegetableEquipment',
        defaultMessage: 'Other Vegetable Equipment',
        description: 'Display name for Other Vegetable Equipment subcategory',
    },
    otherVineyardSpecialistFruitEquipment: {
        id: 'categories.otherVineyardSpecialistFruitEquipment',
        defaultMessage: 'Other Vineyard & Specialist Fruit Equipment',
        description: 'Display name for Other Vineyard & Specialist Fruit Equipment subcategory',
    },
    pickUps: {
        id: 'categories.pickUps',
        defaultMessage: 'Pick Ups',
        description: 'Display name for Pick Ups subcategory',
    },
    pivotIrrigators: {
        id: 'categories.pivotIrrigators',
        defaultMessage: 'Pivot Irrigators',
        description: 'Display name for Pivot Irrigators subcategory',
    },
    planting: {
        id: 'categories.planting',
        defaultMessage: 'Planting',
        description: 'Display name for Planting subcategory',
    },
    ploughs: {
        id: 'categories.ploughs',
        defaultMessage: 'Ploughs',
        description: 'Display name for Ploughs subcategory',
    },
    pneumatic: {
        id: 'categories.pneumatic',
        defaultMessage: 'Pneumatic',
        description: 'Display name for Pneumatic subcategory',
    },
    potatoPlanters: {
        id: 'categories.potatoPlanters',
        defaultMessage: 'Potato Planters',
        description: 'Display name for Potato Planters subcategory',
    },
    potatoStorage: {
        id: 'categories.potatoStorage',
        defaultMessage: 'Potato Storage',
        description: 'Display name for Potato Storage subcategory',
    },
    powerArmsHedgeCutters: {
        id: 'categories.powerArmsHedgeCutters',
        defaultMessage: 'Power Arms/Hedge Cutters',
        description: 'Display name for Power Arms/Hedge Cutters subcategory',
    },
    poweredSeedBedPreparation: {
        id: 'categories.poweredSeedBedPreparation',
        defaultMessage: 'Powered Seed Bed Preparation',
        description: 'Display name for Powered Seed Bed Preparation subcategory',
    },
    powerHarrows: {
        id: 'categories.powerHarrows',
        defaultMessage: 'Power Harrows',
        description: 'Display name for Power Harrows subcategory',
    },
    precisionPlanters: {
        id: 'categories.precisionPlanters',
        defaultMessage: 'Precision Planters',
        description: 'Display name for Precision Planters subcategory',
    },
    pruners: {
        id: 'categories.pruners',
        defaultMessage: 'Pruners',
        description: 'Display name for Pruners subcategory',
    },
    pushOffTrailers: {
        id: 'categories.pushOffTrailers',
        defaultMessage: 'Push Off Trailers',
        description: 'Display name for Push Off Trailers subcategory',
    },
    rakes: {
        id: 'categories.rakes',
        defaultMessage: 'Rakes',
        description: 'Display name for Rakes subcategory',
    },
    rearLoaders: {
        id: 'categories.rearLoaders',
        defaultMessage: 'Rear Loaders',
        description: 'Display name for Rear Loaders subcategory',
    },
    rideOnMowers: {
        id: 'categories.rideOnMowers',
        defaultMessage: 'Ride-On Mowers',
        description: 'Display name for Ride-On Mowers subcategory',
    },
    ridgeFormers: {
        id: 'categories.ridgeFormers',
        defaultMessage: 'Ridge Formers',
        description: 'Display name for Ridge Formers subcategory',
    },
    roadMillingMachines: {
        id: 'categories.roadMillingMachines',
        defaultMessage: 'Road Milling Machines',
        description: 'Display name for Road Milling Machines subcategory',
    },
    roboticLawnmowers: {
        id: 'categories.roboticLawnmowers',
        defaultMessage: 'Robotic Lawnmowers',
        description: 'Display name for Robotic Lawnmowers subcategory',
    },
    rollersPackers: {
        id: 'categories.rollersPackers',
        defaultMessage: 'Rollers/Packers',
        description: 'Display name for Rollers/Packers subcategory',
    },
    rotary: {
        id: 'categories.rotary',
        defaultMessage: 'Rotary',
        description: 'Display name for Rotary subcategory',
    },
    roughTerrainForklfits: {
        id: 'categories.roughTerrainForklfits',
        defaultMessage: 'Rough Terrain Forklfits',
        description: 'Display name for Rough Terrain Forklfits subcategory',
    },
    roughTrimAndSurroundsMowers: {
        id: 'categories.roughTrimAndSurroundsMowers',
        defaultMessage: 'Rough Trim and Surrounds Mowers',
        description: 'Display name for Rough Trim and Surrounds Mowers subcategory',
    },
    round: {
        id: 'categories.round',
        defaultMessage: 'Round',
        description: 'Display name for Round subcategory',
    },
    rowCropPlanters: {
        id: 'categories.rowCropPlanters',
        defaultMessage: 'Row Crop Planters',
        description: 'Display name for Row Crop Planters subcategory',
    },
    saltSpreaders: {
        id: 'categories.saltSpreaders',
        defaultMessage: 'Salt Spreaders',
        description: 'Display name for Salt Spreaders subcategory',
    },
    scrapers: {
        id: 'categories.scrapers',
        defaultMessage: 'Scrapers',
        description: 'Display name for Scrapers subcategory',
    },
    seeding: {
        id: 'categories.seeding',
        defaultMessage: 'Seeding',
        description: 'Display name for Seeding subcategory',
    },
    selfPropelled: {
        id: 'categories.selfPropelled',
        defaultMessage: 'Self Propelled',
        description: 'Display name for Self Propelled subcategory',
    },
    selfPropelledManureSpreaders: {
        id: 'categories.selfPropelledManureSpreaders',
        defaultMessage: 'Self Propelled Manure Spreaders',
        description: 'Display name for Self Propelled Manure Spreaders subcategory',
    },
    selfPropelledMowers: {
        id: 'categories.selfPropelledMowers',
        defaultMessage: 'Self Propelled Mowers',
        description: 'Display name for Self Propelled Mowers subcategory',
    },
    selfPropelledPotatoHarvesters: {
        id: 'categories.selfPropelledPotatoHarvesters',
        defaultMessage: 'Self Propelled Potato Harvesters',
        description: 'Display name for Self Propelled Potato Harvesters subcategory',
    },
    selfPropelledSlurryTankers: {
        id: 'categories.selfPropelledSlurryTankers',
        defaultMessage: 'Self Propelled Slurry Tankers',
        description: 'Display name for Self Propelled Slurry Tankers subcategory',
    },
    selfPropelledSugarBeetHarvesters: {
        id: 'categories.selfPropelledSugarBeetHarvesters',
        defaultMessage: 'Self Propelled Sugar Beet Harvesters',
        description: 'Display name for Self Propelled Sugar Beet Harvesters subcategory',
    },
    separation: {
        id: 'categories.separation',
        defaultMessage: 'Separation',
        description: 'Display name for Separation subcategory',
    },
    serviceContracts: {
        id: 'categories.serviceContracts',
        defaultMessage: 'Service Contracts',
        description: 'Display name for Service Contracts subcategory',
    },
    shakers: {
        id: 'categories.shakers',
        defaultMessage: 'Shakers',
        description: 'Display name for Shakers subcategory',
    },
    silageCutters: {
        id: 'categories.silageCutters',
        defaultMessage: 'Silage Cutters',
        description: 'Display name for Silage Cutters subcategory',
    },
    silageTrailers: {
        id: 'categories.silageTrailers',
        defaultMessage: 'Silage Trailers',
        description: 'Display name for Silage Trailers subcategory',
    },
    siloBlockCutters: {
        id: 'categories.siloBlockCutters',
        defaultMessage: 'Silo Block Cutters',
        description: 'Display name for Silo Block Cutters subcategory',
    },
    siteDumpers: {
        id: 'categories.siteDumpers',
        defaultMessage: 'Site Dumpers',
        description: 'Display name for Site Dumpers subcategory',
    },
    skidders: {
        id: 'categories.skidders',
        defaultMessage: 'Skidders',
        description: 'Display name for Skidders subcategory',
    },
    skidSteerLoaders: {
        id: 'categories.skidSteerLoaders',
        defaultMessage: 'Skid Steer Loaders',
        description: 'Display name for Skid Steer Loaders subcategory',
    },
    slurryPumps: {
        id: 'categories.slurryPumps',
        defaultMessage: 'Slurry Pumps',
        description: 'Display name for Slurry Pumps subcategory',
    },
    slurryTankTrailers: {
        id: 'categories.slurryTankTrailers',
        defaultMessage: 'Slurry Tank Trailers',
        description: 'Display name for Slurry Tank Trailers subcategory',
    },
    smallSquare: {
        id: 'categories.smallSquare',
        defaultMessage: 'Small Square',
        description: 'Display name for Small Square subcategory',
    },
    snowBlowers: {
        id: 'categories.snowBlowers',
        defaultMessage: 'Snow Blowers',
        description: 'Display name for Snow Blowers subcategory',
    },
    snowmobiles: {
        id: 'categories.snowmobiles',
        defaultMessage: 'Snowmobiles',
        description: 'Display name for Snowmobiles subcategory',
    },
    snowPloughs: {
        id: 'categories.snowPloughs',
        defaultMessage: 'Snow Ploughs',
        description: 'Display name for Snow Ploughs subcategory',
    },
    software: {
        id: 'categories.software',
        defaultMessage: 'Software',
        description: 'Display name for Software subcategory',
    },
    soilCompaction: {
        id: 'categories.soilCompaction',
        defaultMessage: 'Soil Compaction',
        description: 'Display name for Soil Compaction subcategory',
    },
    soilCultivation: {
        id: 'categories.soilCultivation',
        defaultMessage: 'Soil Cultivation',
        description: 'Display name for Soil Cultivation subcategory',
    },
    soilTillers: {
        id: 'categories.soilTillers',
        defaultMessage: 'Soil Tillers',
        description: 'Display name for Soil Tillers subcategory',
    },
    standard: {
        id: 'categories.standard',
        defaultMessage: 'Standard',
        description: 'Display name for Standard subcategory',
    },
    steamJets: {
        id: 'categories.steamJets',
        defaultMessage: 'Steam Jets',
        description: 'Display name for Steam Jets subcategory',
    },
    stoneCollecting: {
        id: 'categories.stoneCollecting',
        defaultMessage: 'Stone Collecting',
        description: 'Display name for Stone Collecting subcategory',
    },
    stoneCrushersStoneBurriers: {
        id: 'categories.stoneCrushersStoneBurriers',
        defaultMessage: 'Stone Crushers/Stone Burriers',
        description: 'Display name for Stone Crushers/Stone Burriers subcategory',
    },
    storage: {
        id: 'categories.storage',
        defaultMessage: 'Storage',
        description: 'Display name for Storage subcategory',
    },
    strawMills: {
        id: 'categories.strawMills',
        defaultMessage: 'Straw Mills',
        description: 'Display name for Straw Mills subcategory',
    },
    strawSpreadersBlowers: {
        id: 'categories.strawSpreadersBlowers',
        defaultMessage: 'Straw Spreaders/Blowers',
        description: 'Display name for Straw Spreaders/Blowers subcategory',
    },
    stripTill: {
        id: 'categories.stripTill',
        defaultMessage: 'Strip Till',
        description: 'Display name for Strip Till subcategory',
    },
    subCompactTractors: {
        id: 'categories.subCompactTractors',
        defaultMessage: 'Sub-Compact Tractors',
        description: 'Display name for Sub-Compact Tractors subcategory',
    },
    subsoilers: {
        id: 'categories.subsoilers',
        defaultMessage: 'Subsoilers',
        description: 'Display name for Subsoilers subcategory',
    },
    sugarCaneHarvesters: {
        id: 'categories.sugarCaneHarvesters',
        defaultMessage: 'Sugar Cane Harvesters',
        description: 'Display name for Sugar Cane Harvesters subcategory',
    },
    sugarCanePlanters: {
        id: 'categories.sugarCanePlanters',
        defaultMessage: 'Sugar Cane Planters',
        description: 'Display name for Sugar Cane Planters subcategory',
    },
    suVs: {
        id: 'categories.suVs',
        defaultMessage: "SUV's",
        description: "Display name for SUV's subcategory",
    },
    swathersWindrowers: {
        id: 'categories.swathersWindrowers',
        defaultMessage: 'Swathers & Windrowers',
        description: 'Display name for Swathers & Windrowers subcategory',
    },
    sweepers: {
        id: 'categories.sweepers',
        defaultMessage: 'Sweepers',
        description: 'Display name for Sweepers subcategory',
    },
    tankTrailers: {
        id: 'categories.tankTrailers',
        defaultMessage: 'Tank Trailers',
        description: 'Display name for Tank Trailers subcategory',
    },
    tedders: {
        id: 'categories.tedders',
        defaultMessage: 'Tedders',
        description: 'Display name for Tedders subcategory',
    },
    telemetry: {
        id: 'categories.telemetry',
        defaultMessage: 'Telemetry',
        description: 'Display name for Telemetry subcategory',
    },
    telescopicHandlers: {
        id: 'categories.telescopicHandlers',
        defaultMessage: 'Telescopic Handlers',
        description: 'Display name for Telescopic Handlers subcategory',
    },
    telescopicWheeledLoaders: {
        id: 'categories.telescopicWheeledLoaders',
        defaultMessage: 'Telescopic Wheeled Loaders',
        description: 'Display name for Telescopic Wheeled Loaders subcategory',
    },
    terminals: {
        id: 'categories.terminals',
        defaultMessage: 'Terminals',
        description: 'Display name for Terminals subcategory',
    },
    timberHarvesters: {
        id: 'categories.timberHarvesters',
        defaultMessage: 'Timber Harvesters',
        description: 'Display name for Timber Harvesters subcategory',
    },
    timberTrailers: {
        id: 'categories.timberTrailers',
        defaultMessage: 'Timber Trailers',
        description: 'Display name for Timber Trailers subcategory',
    },
    tineWeeders: {
        id: 'categories.tineWeeders',
        defaultMessage: 'Tine Weeders',
        description: 'Display name for Tine Weeders subcategory',
    },
    tippingTrailers: {
        id: 'categories.tippingTrailers',
        defaultMessage: 'Tipping Trailers',
        description: 'Display name for Tipping Trailers subcategory',
    },
    tmrMixers: {
        id: 'categories.tmrMixers',
        defaultMessage: 'TMR Mixers',
        description: 'Display name for TMR Mixers subcategory',
    },
    tmrMixersSelfPropelled: {
        id: 'categories.tmrMixersSelfPropelled',
        defaultMessage: 'TMR Mixers Self Propelled',
        description: 'Display name for TMR Mixers Self Propelled subcategory',
    },
    topDressers: {
        id: 'categories.topDressers',
        defaultMessage: 'Top Dressers',
        description: 'Display name for Top Dressers subcategory',
    },
    tracked: {
        id: 'categories.tracked',
        defaultMessage: 'Tracked',
        description: 'Display name for Tracked subcategory',
    },
    trackedDumpers: {
        id: 'categories.trackedDumpers',
        defaultMessage: 'Tracked Dumpers',
        description: 'Display name for Tracked Dumpers subcategory',
    },
    trackedExcavators: {
        id: 'categories.trackedExcavators',
        defaultMessage: 'Tracked Excavators',
        description: 'Display name for Tracked Excavators subcategory',
    },
    tractorAccessories: {
        id: 'categories.tractorAccessories',
        defaultMessage: 'Tractor Accessories',
        description: 'Display name for Tractor Accessories subcategory',
    },
    trailed: {
        id: 'categories.trailed',
        defaultMessage: 'Trailed',
        description: 'Display name for Trailed subcategory',
    },
    trailedCompostSpreaders: {
        id: 'categories.trailedCompostSpreaders',
        defaultMessage: 'Trailed Compost Spreaders',
        description: 'Display name for Trailed Compost Spreaders subcategory',
    },
    trailedMountedManureSpreaders: {
        id: 'categories.trailedMountedManureSpreaders',
        defaultMessage: 'Trailed/Mounted Manure Spreaders',
        description: 'Display name for Trailed/Mounted Manure Spreaders subcategory',
    },
    trailedMountedMowers: {
        id: 'categories.trailedMountedMowers',
        defaultMessage: 'Trailed/Mounted Mowers',
        description: 'Display name for Trailed/Mounted Mowers subcategory',
    },
    trailedMountedSlurryTankers: {
        id: 'categories.trailedMountedSlurryTankers',
        defaultMessage: 'Trailed/Mounted Slurry Tankers',
        description: 'Display name for Trailed/Mounted Slurry Tankers subcategory',
    },
    trailedPotatoHarvesters: {
        id: 'categories.trailedPotatoHarvesters',
        defaultMessage: 'Trailed Potato Harvesters',
        description: 'Display name for Trailed Potato Harvesters subcategory',
    },
    trailedSugarBeetHarvesters: {
        id: 'categories.trailedSugarBeetHarvesters',
        defaultMessage: 'Trailed Sugar Beet Harvesters',
        description: 'Display name for Trailed Sugar Beet Harvesters subcategory',
    },
    trailers: {
        id: 'categories.trailers',
        defaultMessage: 'Trailers',
        description: 'Display name for Trailers subcategory',
    },
    transmissions: {
        id: 'categories.transmissions',
        defaultMessage: 'Transmissions',
        description: 'Display name for Transmissions subcategory',
    },
    transverse: {
        id: 'categories.transverse',
        defaultMessage: 'Transverse',
        description: 'Display name for Transverse subcategory',
    },
    trellisingAndWireLiftingMachines: {
        id: 'categories.trellisingAndWireLiftingMachines',
        defaultMessage: 'Trellising and Wire Lifting Machines',
        description: 'Display name for Trellising and Wire Lifting Machines subcategory',
    },
    trucksHgv: {
        id: 'categories.trucksHgv',
        defaultMessage: 'Trucks - HGV',
        description: 'Display name for Trucks - HGV subcategory',
    },
    trucksNonHgv: {
        id: 'categories.trucksNonHgv',
        defaultMessage: 'Trucks - Non HGV',
        description: 'Display name for Trucks - Non HGV subcategory',
    },
    turfSprayers: {
        id: 'categories.turfSprayers',
        defaultMessage: 'Turf Sprayers',
        description: 'Display name for Turf Sprayers subcategory',
    },
    turnableDrawbarTrailers: {
        id: 'categories.turnableDrawbarTrailers',
        defaultMessage: 'Turnable Drawbar Trailers',
        description: 'Display name for Turnable Drawbar Trailers subcategory',
    },
    underplantCultivators: {
        id: 'categories.underplantCultivators',
        defaultMessage: 'Underplant Cultivators',
        description: 'Display name for Underplant Cultivators subcategory',
    },
    underplantMulchers: {
        id: 'categories.underplantMulchers',
        defaultMessage: 'Underplant Mulchers',
        description: 'Display name for Underplant Mulchers subcategory',
    },
    vans: {
        id: 'categories.vans',
        defaultMessage: 'Vans',
        description: 'Display name for Vans subcategory',
    },
    vegetableHarvesting: {
        id: 'categories.vegetableHarvesting',
        defaultMessage: 'Vegetable Harvesting',
        description: 'Display name for Vegetable Harvesting subcategory',
    },
    vegetablePlantingMachines: {
        id: 'categories.vegetablePlantingMachines',
        defaultMessage: 'Vegetable Planting Machines',
        description: 'Display name for Vegetable Planting Machines subcategory',
    },
    vegetableProcessing: {
        id: 'categories.vegetableProcessing',
        defaultMessage: 'Vegetable Processing',
        description: 'Display name for Vegetable Processing subcategory',
    },
    ventilationFans: {
        id: 'categories.ventilationFans',
        defaultMessage: 'Ventilation Fans',
        description: 'Display name for Ventilation Fans subcategory',
    },
    verticalTillage: {
        id: 'categories.verticalTillage',
        defaultMessage: 'Vertical Tillage',
        description: 'Display name for Vertical Tillage subcategory',
    },
    vineStockLifters: {
        id: 'categories.vineStockLifters',
        defaultMessage: 'Vine Stock Lifters',
        description: 'Display name for Vine Stock Lifters subcategory',
    },
    vsf: {
        id: 'categories.vsf',
        defaultMessage: 'VSF',
        description: 'Display name for VSF subcategory',
    },
    walkers: {
        id: 'categories.walkers',
        defaultMessage: 'Walkers',
        description: 'Display name for Walkers subcategory',
    },
    wheeledExcavators: {
        id: 'categories.wheeledExcavators',
        defaultMessage: 'Wheeled Excavators',
        description: 'Display name for Wheeled Excavators subcategory',
    },
    wheeledLoaders: {
        id: 'categories.wheeledLoaders',
        defaultMessage: 'Wheeled Loaders',
        description: 'Display name for Wheeled Loaders subcategory',
    },
    windrowerHeaders: {
        id: 'categories.windrowerHeaders',
        defaultMessage: 'Windrower Headers',
        description: 'Display name for Windrower Headers subcategory',
    },
    woodChippers: {
        id: 'categories.woodChippers',
        defaultMessage: 'Wood Chippers',
        description: 'Display name for Wood Chippers subcategory',
    },
    zeroTurnMowers: {
        id: 'categories.zeroTurnMowers',
        defaultMessage: 'Zero Turn Mowers',
        description: 'Display name for Zero Turn Mowers subcategory',
    },
});
exports.default = messages;
